/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Projects_Cta_LedeInputs */

const en_projects_cta_lede = /** @type {(inputs: Projects_Cta_LedeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tell us about the process or product you want to improve.`)
};

const lv_projects_cta_lede = /** @type {(inputs: Projects_Cta_LedeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pastāstiet par procesu vai produktu, ko gribētu uzlabot.`)
};

/**
* | output |
* | --- |
* | "Tell us about the process or product you want to improve." |
*
* @param {Projects_Cta_LedeInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const projects_cta_lede = /** @type {((inputs?: Projects_Cta_LedeInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Projects_Cta_LedeInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_projects_cta_lede(inputs)
	return en_projects_cta_lede(inputs)
});